import PropTypes from 'prop-types';

import { useFnol } from '../../../context';
import ListItem from '../../../components/ListItem';

const ReportTypeItem = ({ template, onClick }) => {
  const { selectedFnolTemplate } = useFnol();

  const handleClick = () => onClick(template);
  return (
    <ListItem
      selected={
        selectedFnolTemplate && template.name === selectedFnolTemplate.name
      }
      onClick={handleClick}
    >
      <h4>{template.name}</h4>
      <div>{template.description}</div>
    </ListItem>
  );
};

ReportTypeItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  template: PropTypes.shape({
    description: PropTypes.string,
    name: PropTypes.string.isRequired,
  }),
};

export default ReportTypeItem;
